import { ERROR_PATH, ROOT_PATH, SDK_DEMO_PATH, TRANSACTION_PATH } from 'app/shared/consts';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { AppContentWrapper } from 'app/components/app-content-wrapper/app-content-wrapper';
import { BookingDetailPage } from 'app/pages/booking-detail';
import { ErrorPage } from 'app/pages/error';
import { MiniappActivityCenterPage } from 'app/pages/miniapp-activity-center';
import { MiniappSdkDemoPage } from 'app/pages/miniapp-sdk-demo';
import { Private } from 'app/components/router/private';
import React from 'react';

/**
 * Anything that isn't a known route — including the bare `/` the host launches at — resolves to the
 * feed, carrying the query string across: the launch params (authToken, apiUrl, buildingUuid) live
 * there, and dropping them would land on a dead shell. `replace` keeps the launch url out of history
 * and means only the canonical `/feed` is ever reported as a route.
 */
const RedirectToFeed = (): JSX.Element => {
  const { search } = useLocation();

  return <Navigate to={{ pathname: ROOT_PATH, search }} replace />;
};

export const AppRouter: React.FC = (): JSX.Element => (
  <AppContentWrapper>
    <Routes>
      <Route path={TRANSACTION_PATH} element={<Private><BookingDetailPage /></Private>} />
      <Route path={ROOT_PATH} element={<Private><MiniappActivityCenterPage /></Private>} />
      <Route path={SDK_DEMO_PATH} element={<MiniappSdkDemoPage />} />
      <Route path={ERROR_PATH} element={<ErrorPage />} />
      <Route path="*" element={<RedirectToFeed />} />
    </Routes>
  </AppContentWrapper>
);
